import { Copy, FileCheck2, Upload } from "lucide-react";
import { toast } from "sonner";
import { clp } from "@/lib/format";

const BANK = [["bank_name", "Banco"], ["account_type", "Tipo de cuenta"], ["account_number", "Número de cuenta"],
  ["holder", "Titular"], ["rut", "RUT"], ["email", "Correo"]];

const copy = (v, l) => navigator.clipboard?.writeText(String(v)).then(() => toast.success(`${l} copiado`)).catch(() => toast.error("No se pudo copiar"));

export function StepTransfer({ bank, deposit, file, setFile, showErrors }) {
  return (
    <div data-testid="step-transfer" className="space-y-6">
      <div className="rounded-3xl bg-[#1F2421] text-[#FAF7F2] p-6">
        <p className="eyebrow !text-[#E5DCCB]">Monto a transferir (abono)</p>
        <div className="mt-2 flex items-center justify-between gap-3">
          <p className="font-serif text-4xl" data-testid="transfer-amount">{clp(deposit)}</p>
          <button type="button" onClick={() => copy(deposit, "Monto")} data-testid="copy-amount-btn"
            className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold hover:bg-white/20 transition-colors">
            <Copy className="h-4 w-4" /> Copiar
          </button>
        </div>
      </div>
      <div className="rounded-3xl bg-white border border-border divide-y divide-border" data-testid="bank-details">
        {BANK.map(([k, l]) => (
          <div key={k} className="flex items-center justify-between gap-3 px-5 py-3.5">
            <div className="min-w-0">
              <p className="text-xs text-muted-foreground">{l}</p>
              <p className="font-semibold truncate" data-testid={`bank-${k}`}>{bank?.[k]}</p>
            </div>
            <button type="button" onClick={() => copy(bank?.[k], l)} data-testid={`copy-${k}-btn`} aria-label={`Copiar ${l}`}
              className="h-10 w-10 shrink-0 rounded-full grid place-items-center text-[#5E6B52] hover:bg-[#E9EFE6] transition-colors">
              <Copy className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
      <div>
        <p className="font-semibold mb-2">Comprobante de transferencia *</p>
        <label className={`flex flex-col items-center justify-center gap-2 rounded-3xl border-2 border-dashed p-8 text-center cursor-pointer transition-colors hover:bg-[#E9EFE6]/50 ${showErrors && !file ? "border-red-500" : file ? "border-[#5E6B52] bg-[#E9EFE6]/40" : "border-border bg-white"}`}
          data-testid="receipt-dropzone">
          {file ? <FileCheck2 className="h-8 w-8 text-[#5E6B52]" /> : <Upload className="h-8 w-8 text-muted-foreground" />}
          <span className="text-sm font-medium" data-testid="receipt-file-name">{file ? file.name : "Sube una captura o PDF del comprobante"}</span>
          <span className="text-xs text-muted-foreground">JPG, PNG, WEBP, HEIC o PDF · máx. 10 MB</span>
          <input type="file" accept="image/*,application/pdf" className="hidden" data-testid="receipt-file-input"
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f && f.size > 10 * 1024 * 1024) { toast.error("El archivo supera 10 MB"); return; }
              setFile(f || null);
            }} />
        </label>
        {showErrors && !file && <p className="mt-2 text-sm text-red-600" data-testid="receipt-error">Debes adjuntar el comprobante para enviar la solicitud.</p>}
      </div>
    </div>
  );
}
